/* eslint-disable */
import React from "react";
import styles from "./ProgramEpisodeList.module.css";
import { Video } from "../../../../stores/program/model/Program";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";

interface ProgramEpisodeProps {
  // ビデオリスト
  videoList: Video[];
  // 選択されたビデオ
  selected: Video | undefined;
  // セレクトエリア用コールバック関数
  onCallback: any;
}

export default function ProgramEpisodeList({
  videoList,
  selected,
  onCallback,
}: ProgramEpisodeProps) {
  // エピソードエリアをクリック時
  const changeFocus = (video: Video, index: number) => {
    onCallback(video, index);
  };

  return (
    <>
      <div className={styles.container}>
        {videoList.map((video, idx) => (
          <div key={video.id}>
            <div className={styles.thumbRow}>
              <div className={styles.videoIndex}>
                <PuiTypography size={14} bold={true} color={"gray-61"}>
                  {idx + 1}
                </PuiTypography>
              </div>
              <div className={styles.videoThumb} onClick={() => changeFocus(video, idx)}>
                <img
                  src={video.imageUrl}
                  className={styles.img}
                  style={{
                    border: selected?.id === video.id ? "3px solid var(--red)" : "",
                  }}
                  alt={video.title}
                />
              </div>
            </div>
            <div className={styles.titleRow} data-tip={video.title} data-for="title">
              <PuiTypography size={14} bold={true}>
                {video.title}
              </PuiTypography>
            </div>
            <PuiTooltip id={"title"} />
          </div>
        ))}
      </div>
    </>
  );
}
